<template>
    <ModalFormCard :action='"/admin/location-area/"+editingModel.id+"/set-trades"' :submittedCallback="submittedCallback" class="modal-default">
        <template #title>{{ editingModel.name }}</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="company_id" :value="editingModel.id" />

            <p class='text-15 font-semibold'>Select all trades that you want to block from this location</p>

            <div class='grid grid-cols-2 gap-2 mt-4'>
                <InputCheckbox v-for='trade in user.industries' name='trades[]' 
                    :value='trade.id' :checked="editingModel.disabled_trades.find(d => d.industry_id == trade.id)">
                    <p class='text-14 pl-2'>{{ trade.name }}</p>
                </InputCheckbox>
            </div>

            <div class="modal-buttons">
                <ButtonSaving class="button-black h-12 default" :saving="saving">
                    Update location
                </ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    data() {
        return {
        }
    },

    methods: {

    },

    computed: {
        user() {
            return this.$authSanctum.getUser()
        }
    },
}
</script>
